<div class="cropper-overlay">
    <div class="cropper-modal-v2">
        <h3 class="cropper-title">Upload image</h3>

        <div class="cropper-container">
            <img #cropperImage [src]="imageUrl" (load)="cropperLoad()" alt="cropped-image">
        </div>

        <div class="divider"></div>

        <div class="cropper-footer">
            <button class="cancel-btn" (click)="cancelCropper()">Cancel</button>
            <button class="save-btn" (click)="saveCroppedImage()">Save</button>
        </div>
    </div>
</div>
